<section class="mt-2 pr-2">
    <h4>{{translate.getLng('CUST_ADDR')}}</h4>
    <!-- <p class="sen-fs12">{{translate.getLng('PLEASE_ENTER_CUSTOMER')}}</p> -->
    <sen-app-customer-data [type]="type" (emitAddress)="emitAddress($event)" [phoneNumber]="false" [data]="data">
    </sen-app-customer-data>
</section>